import React, { Component } from 'react';
import { Divider, Button, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Pet extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      PickPetInventorySize: 28,
      MaxPetLevel: 120,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Pet Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>Monkey Inventory Size</td>
              <td>
                <NumericInput
                  style={{ width: '160px' }}
                  value={this.state.PickPetInventorySize}
                  placeholder="Type inventory size..."
                  onValueChange={this.handleChange('PickPetInventorySize')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Pet Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '160px' }}
                  value={this.state.MaxPetLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('MaxPetLevel')}
                  className="mb-4"
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
